import { Component, EventEmitter, Injectable, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-barra-consulta-export',
  templateUrl: './barra-consulta-export.component.html',
  styleUrls: ['./barra-consulta-export.component.css']
})

@Injectable({
  providedIn: 'root'
})
export class BarraConsultaExportComponent  implements OnInit {
  bloquearBotaoNovoCadastro: any;

  @Input() exibirBarraCor = true;
  @Input() exibirBotaoDefinirFiltros = true;
  @Input() exibirBotaoAjuda = true;
  @Input() exibirNovo = true;
  @Input() listagemComFiltros = false;
  @Output() inserindo   = new EventEmitter();
  @Output() atualizando = new EventEmitter();
  @Output() definirFiltro:    EventEmitter<any> = new EventEmitter<any>();
  @Input() detalhe: any = null;

  constructor() {
  }

  ngOnInit() {
  }

  buscarRegistros() {
    this.atualizando.emit(true);
  }

  criar() {
    this.inserindo.emit(true);
  }

  definirFiltragem() {
    this.definirFiltro.emit();
  }

}
